// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"91":"75c3bc25","741":"847eeeeb"}[chunkId] + ".chunk.js";
};